(() => {
  if (window.__eamdProductCardLoaded) return;
  window.__eamdProductCardLoaded = true;

  // Product cards come from a compiled React island (`ProductGridIsland`). This layer
  // only regroups the existing title/price into a footer with its own ground and adds
  // the cart affordance; it never rewrites the card.
  // 🔴 El MISMO dibujo que el carrito del encabezado (la bolsa, viewBox 24, trazo): fixpack
  // second-cart-glyph-in-store. Antes era un carrito con ruedas propio, que aparecería en cuanto un
  // producto entrara en la lista de «agregar directo» y la tienda tendría dos iconos de carrito.
  const CART_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

  const handleOf = (link) => {
    const href = link.getAttribute('href') || '';
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  };

  /**
   * QUIÉN LLEVA BOTÓN DE AGREGAR EN LA TARJETA.
   *
   * Regla de negocio (Max, 2026-09-08): solo los productos SIN variantes que elegir y sin
   * personalización. Un collar de dos iniciales no se puede comprar desde una rejilla: lo
   * que llegaría al taller es un pedido sin las letras.
   *
   * La lista la calcula Liquid en `snippets/eamd-quick-add-elegibles.liquid`, que es el
   * único sitio donde se ven a la vez variantes, metacampos y la receta de la app. Aquí solo
   * se lee. 🔴 Si la lista no está, NADIE lleva botón: la puerta falla cerrada, porque el
   * fallo contrario es un pedido imposible de fabricar.
   */
  let elegibles = null;
  const puedeAgregarse = (handle) => {
    if (elegibles === null) {
      const nodo = document.querySelector('script[type="application/json"][data-eamd-quick-add-elegibles]');
      try {
        const lista = nodo ? JSON.parse(nodo.textContent) : [];
        elegibles = new Set((Array.isArray(lista) ? lista : []).filter(Boolean));
      } catch (_) {
        elegibles = new Set();
      }
    }
    return elegibles.has(handle);
  };

  /**
   * COMPUESTOS SIN PIEZAS: la tarjeta lleva «Agotado».
   *
   * La lista la publica `snippets/eamd-quick-add-elegibles.liquid` (`data-eamd-compuestos-agotados`)
   * desde el metacampo `composicion_stock.agotado` del producto padre. La rejilla la pinta el
   * bundle compilado, así que aquí solo se rotula la tarjeta ya montada; no se reordena (eso lo
   * hace el Liquid de la colección). Sin lista, o sin metacampo, no se toca ninguna tarjeta.
   */
  let agotados = null;
  const datosAgotados = () => {
    if (agotados === null) {
      agotados = { etiqueta: 'Agotado', handles: new Set() };
      const nodo = document.querySelector('script[type="application/json"][data-eamd-compuestos-agotados]');
      try {
        const d = nodo ? JSON.parse(nodo.textContent) : null;
        if (typeof d?.etiqueta === 'string' && d.etiqueta.trim()) agotados.etiqueta = d.etiqueta.trim();
        agotados.handles = new Set((Array.isArray(d?.handles) ? d.handles : []).filter(Boolean));
      } catch (_) { /* lista ilegible: ninguna tarjeta se rotula */ }
    }
    return agotados;
  };

  /** Idempotente: la isla compilada puede repintar la tarjeta y llevarse la etiqueta. */
  const rotularAgotado = (link, handle, media) => {
    const datos = datosAgotados();
    if (!datos.handles.has(handle)) return;
    link.dataset.eamdAgotado = 'true';
    if (!media || media.querySelector('.eamd-card-agotado')) return;
    // La etiqueta se posiciona sobre la foto: el bloque de medios tiene que ser su referencia.
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    const etiqueta = document.createElement('span');
    etiqueta.className = 'eamd-card-agotado';
    etiqueta.textContent = datos.etiqueta;
    media.append(etiqueta);
  };

  /**
   * Las etiquetas de «agregado rápido» que la página publica.
   *
   * 🔴 El botón que el comprador ve NO es el nuestro. La rejilla de colección la pinta el
   * bundle compilado (`CollectionIsland`) y ÉL dibuja su propia franja «Agregar rápido» sobre
   * la foto — medido: `absolute bottom-0 left-0 right-0 bg-prim…`. Quitar solo `.eamd-card-cart`
   * dejaba la franja intacta y la sonda decía «0 botones» tan tranquila.
   *
   * El texto no se escribe a mano: sale del mismo payload que lo pinta
   * (`cardQuickAddLabel`), así que si el comerciante lo cambia en el editor, esto lo sigue.
   */
  let etiquetas = null;
  const etiquetasAgregado = () => {
    if (etiquetas === null) {
      etiquetas = new Set();
      document.querySelectorAll('script[type="application/json"]').forEach((s) => {
        try {
          const d = JSON.parse(s.textContent);
          for (const clave of ['cardQuickAddLabel', 'quickAddLabel', 'productAddLabel']) {
            if (typeof d?.[clave] === 'string' && d[clave].trim()) etiquetas.add(d[clave].trim().toLowerCase());
          }
        } catch (_) { /* no todo `application/json` de la página es nuestro */ }
      });
    }
    return etiquetas;
  };

  /** Borra la franja de agregado rápido que pinta el bundle compilado dentro de una tarjeta. */
  const quitarAgregadoCompilado = (link) => {
    const etqs = etiquetasAgregado();
    link.querySelectorAll('button, [role="button"]').forEach((b) => {
      if (b.classList.contains('eamd-card-cart')) return;
      const texto = (b.textContent || '').trim().toLowerCase();
      if (!texto) return; // las muestras de color no llevan texto: no se tocan
      // Con etiqueta publicada, coincidencia exacta. Sin ella, el respaldo es un control con
      // texto colocado en absoluto sobre la foto, que es lo único que puede ser esa franja.
      const coincide = etqs.size ? etqs.has(texto) : getComputedStyle(b).position === 'absolute';
      if (coincide) b.remove();
    });
  };

  const enhance = (link) => {
    if (link.dataset.eamdCardReady === 'true') {
      // Ya montada. Solo se vuelve a barrer la franja: si la isla compilada repinta la
      // tarjeta, el botón reaparece y el guardia de «ya lista» lo dejaría pasar.
      if (link.dataset.eamdHandle && !puedeAgregarse(link.dataset.eamdHandle)) quitarAgregadoCompilado(link);
      if (link.dataset.eamdHandle) rotularAgotado(link, link.dataset.eamdHandle, link.querySelector('div'));
      return;
    }
    const handle = handleOf(link);
    if (!handle) return;
    // The media block is the card's first element; everything after it is the copy.
    const media = link.querySelector('div');
    if (!media) return;
    const copyNodes = Array.from(link.children).filter((node) => node !== media);
    if (!copyNodes.length) return;

    link.dataset.eamdCardReady = 'true';
    link.dataset.eamdHandle = handle;
    rotularAgotado(link, handle, media);

    const foot = document.createElement('div');
    foot.className = 'eamd-card-foot';
    const copy = document.createElement('div');
    copy.className = 'eamd-card-foot__copy';
    copyNodes.forEach((node) => copy.append(node));

    // El pie se arma siempre (es lo que reagrupa título y precio); el botón, solo si el
    // producto se puede comprar sin decidir nada.
    if (!puedeAgregarse(handle)) {
      quitarAgregadoCompilado(link);
      foot.append(copy);
      link.append(foot);
      return;
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'eamd-card-cart';
    button.innerHTML = CART_ICON;
    button.dataset.ddCta = 'card-quick-view';
    button.setAttribute('aria-label', 'Agregar al carrito');

    button.addEventListener('click', (event) => {
      // The card is a link; the button must not follow it.
      event.preventDefault();
      event.stopPropagation();

      // Canonical opener from `quick-view-drawer-standard.md`. A host may or may not
      // be mounted yet; `quickview:handled` is how it acknowledges.
      const opener = new CustomEvent('quickview:open', {
        bubbles: true,
        cancelable: true,
        detail: { handle, url: link.getAttribute('href') }
      });
      const delivered = !document.dispatchEvent(opener);

      // No host listening: never leave a dead control — go to the product page.
      if (!delivered) window.location.href = link.getAttribute('href');
    });

    foot.append(copy, button);
    link.append(foot);
  };

  const scan = () => {
    document.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      // Only real product cards: a link wrapping its own media block.
      if (!link.querySelector('img')) return;
      if (link.closest('[data-eamd-review-card], [data-eamd-cart-rec], [data-eamd-search]')) return;
      enhance(link);
    });
  };

  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = 0; scan(); });
  };

  const start = () => {
    scan();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
